import React from 'react';
import Css from './Display.module.css';
import { useMediaQuery } from 'react-responsive';
import Filter from './Filter/Filter';
import BlockDisplay from './BlockDisplay/BlockDisplay';
import BlockDisplayMoby from './BlockDisplayMoby/BlockDisplayMoby';



function Display(props) {

    const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 })
    const isBigScreen = useMediaQuery({ minWidth: 1824 })
    const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const isRetina = useMediaQuery({ minResolution: '2dppx' })
    return (
        <div className={Css.contentCatalog}>
            <div className={Css.content}>
                {isDesktopOrLaptop && <BlockDisplay {...props} />}
                {/* {isPortrait   &&  <BlockDisplayMoby {...props}/> } */}
                {isTabletOrMobile && <BlockDisplayMoby {...props} />}
                {isDesktopOrLaptop && <Filter {...props} />}
            </div>
        </div>
    )
}

export default Display;